class CardMediaSlider {
  constructor(sliderEl) {
    this.sliderEl = sliderEl;
    this.track = sliderEl.querySelector('[data-slider-track]');
    this.slides = Array.from(sliderEl.querySelectorAll('.card-media-slider__slide'));
    this.current = 0;
    this.total = this.slides.length;
    if (this.total <= 1) return;

    // Nav link and buttons are rendered server-side when media.size > 1
    const navLink = sliderEl.querySelector('.card-media-slider__nav-link');

    // Build indicator dots
    const nav = document.createElement('div');
    nav.className = 'card-media-slider__indicators';
    this.indicators = Array.from({ length: this.total }, (_, i) => {
      const dot = document.createElement('span');
      dot.className = 'card-media-slider__indicator' + (i === 0 ? ' is-active' : '');
      nav.appendChild(dot);
      return dot;
    });
    sliderEl.appendChild(nav);

    // Arrow buttons
    const prev = sliderEl.querySelector('.card-media-slider__btn--prev');
    const next = sliderEl.querySelector('.card-media-slider__btn--next');
    if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.go(this.current - 1); });
    if (next) next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.go(this.current + 1); });

    // Mobile swipe
    let startX = 0, startY = 0, isH = null;

    sliderEl.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      isH = null;
    }, { passive: true });

    sliderEl.addEventListener('touchmove', (e) => {
      const t = e.touches[0];
      if (isH === null) {
        const dx = Math.abs(t.clientX - startX);
        const dy = Math.abs(t.clientY - startY);
        if (dx < 5 && dy < 5) return;
        isH = dx > dy;
      }
      if (isH) e.preventDefault();
    }, { passive: false });

    sliderEl.addEventListener('touchend', (e) => {
      if (!e.changedTouches.length) return;
      const t = e.changedTouches[0];
      const dx = startX - t.clientX;
      const dy = startY - t.clientY;
      const wasTap = Math.abs(dx) < 10 && Math.abs(dy) < 10;

      if (isH && Math.abs(dx) > 30) {
        dx > 0 ? this.go(this.current + 1) : this.go(this.current - 1);
        if (navLink) {
          navLink.style.pointerEvents = 'none';
          setTimeout(() => { navLink.style.pointerEvents = ''; }, 400);
        }
      } else if (wasTap && navLink) {
        window.location.href = navLink.href;
      }
      isH = null;
    }, { passive: true });
  }

  go(index) {
    this.current = ((index % this.total) + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    if (this.indicators) {
      this.indicators.forEach((el, i) => el.classList.toggle('is-active', i === this.current));
    }
  }
}

function initCardMediaSliders(root) {
  (root || document).querySelectorAll('[data-card-slider]').forEach((el) => {
    if (!el.dataset.sliderInit) {
      el.dataset.sliderInit = '1';
      new CardMediaSlider(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCardMediaSliders());
} else {
  initCardMediaSliders();
}
window.initCardMediaSliders = initCardMediaSliders;
